import {
  start as startOptimizelyClient,
  isFeatureEnabled,
  getEnabledFeatures,
  activate,
  getVariation,
  track
} from '@greenlight/optimizely-client';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const OptimizelyClient = {
  isFeatureEnabled,
  getEnabledFeatures,
  activate,
  getVariation,
  track
};

let isStarted = false;
function start() {
  const config = {
    optimizelyHost: publicRuntimeConfig.optimizelyHost,
    useHttp: true // We can't use gRPC from front-end, so force http interface
  };

  // Make sure that we don't double load the client
  if (!isStarted) {
    startOptimizelyClient(config);
    isStarted = true;
  }
  return OptimizelyClient;
}

export default {
  ...OptimizelyClient,
  start
};
